var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.options, function (option, index) {
      return _c(
        "div",
        { key: "option" + index, staticClass: "preferences-propver__content" },
        [
          _c("h3", [_vm._v(" " + _vm._s(option.label) + " ")]),
          _c("p", [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("Search.propver.Preferences.algorithm." + option.key)
                ) +
                " "
            ),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }